import { render, staticRenderFns } from "./remCom.vue?vue&type=template&id=75a11607&scoped=true"
import script from "./remCom.vue?vue&type=script&lang=js"
export * from "./remCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/rem.css?vue&type=style&index=0&id=75a11607&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a11607",
  null
  
)

export default component.exports